import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { PlainTooltip } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { ButtonLinkContainer } from "../KeywordsQueryBarStyles";
import { KEYWORD_TOOLTIP } from "../constants";

export const OpenLinkButton = ({ googleLink }: { googleLink: string }) => {
    const translate = useTranslation();
    return (
        <PlainTooltip
            placement="bottom"
            tooltipContent={translate(KEYWORD_TOOLTIP)}
        >
            <ButtonLinkContainer
                href={googleLink}
                target="_blank"
            >
                <IconButton
                    type="flat"
                    iconName="google"
                />
            </ButtonLinkContainer>
        </PlainTooltip>
    );
};
